export default __webpack_public_path__ + "static/media/220.255e97a9.jpg";